/* eslint-disable react-hooks/exhaustive-deps */
import { useRef, useEffect, useState, Fragment } from 'react';
import MainHeader from "../../../../Shared/components/Header";
import customStyles from "../../../../../assets/styles/customStyles";
import { CustomForm } from './CustomForm';
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import crudActions from "../../../../CRUD/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import { AESDecrypt } from "../../../../../helpers/Crypto";
import { toast } from 'react-toastify';
import { checkCRUDViewPermission } from "../../../../../helpers/utilities";
import ProductIcon from "../../../../../assets/images/icon_menus/ProductIcon.json";
import salesActions from "../../../../Sales/Management/redux/actions";
import purchaseActions from "../../../../Purchase/Management/redux/actions";

const AdjustStockCreate = (props) => {
    const { readDetails, readError } = useSelector(state => state.crudReducer);
    const { roleManagement } = useSelector(state => state.authReducer);
    const formRef = useRef('');
    const { history } = props;
    const dispatch = useDispatch();
    let { stockId } = useParams();
    const decryptedId = AESDecrypt(stockId);
    const [view, setView] = useState(false);
    const { type } = useParams();
    const prevReadDetails = usePrevious(readDetails);
    const [showDetails, setShowDetails] = useState(true);


    useEffect(() => {
        if (stockId !== undefined && decryptedId === 0) {
            history.push('/product/inventory/adjust-stock');
            return true;
        }
        if (roleManagement !== '' && checkCRUDViewPermission('Adjust Stock', type, history, 'Product')) {
            loadTask();
        }
        if (type === 'view') {
            setView(true);
        } else {
            setView(false);
        }
    }, [stockId, type, roleManagement]);


    const loadTask = () => {
        if (stockId) {
            dispatch({ type: crudActions.READ_DETAILS_START, id: decryptedId, url: "stockAdjustment" });
        } else {
            customerApi();
            supplierApi();
        }
    }


    const customerApi = (search = '', id = '') => {
        let filter = { or: [] };
        if (search) {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ mobile: { like: '%' + search.trim() + '%' } });
        }

        if (id) {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: salesActions.CUSTOMER_DETAILS_START, url: 'customerProfile',
            filter: {
                where: !filter.or || filter.or.length === 0 ? {} : filter,
                order: 'id desc',
                limit: 20,
                skip: 0
            },
        });
    }

    const supplierApi = (search = '', id = '') => {
        let filter = { or: [] };
        if (search) {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ mobile: { like: '%' + search.trim() + '%' } });
        }

        if (id) {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: purchaseActions.SUPPLIER_DETAILS_START, url: 'supplierProfile',
            filter: {
                where: !filter.or || filter.or.length === 0 ? {} : filter,
                order: 'id desc',
                limit: 20,
                skip: 0
            },
        });
    }



    useEffect(() => {
        if (prevReadDetails !== undefined && readDetails && prevReadDetails !== readDetails) {
            setShowDetails(false);
            if (type === 'view' || readDetails?.adjustMentStatus === 'CONFIRMED') {
                setView(true);
            } else {
                setView(false);
            }
            formRef.current.onEdit(readDetails);
            if (readDetails?.customerId) {
                customerApi('', readDetails?.customerId);
            }
            if (readDetails?.supplierId) {
                supplierApi('', readDetails?.supplierId);
            }
        } else if (readError) {
            if (readError.error.statusCode) {
                toast.error('Adjust Stock ID is invalid');
            }
        }
    }, [readDetails, readError]);

    const classes = customStyles();
    return (
        <Fragment>
            <MainHeader {...props} cls={'newImg'} img={ProductIcon} title={'Product'}
                links={[{ 'label': 'Product', 'link': '/product' }, { 'label': 'Adjust Stock', 'link': '' }]}
                closeLink={'/product/inventory/adjust-stock'}
            />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableSticky, { [classes.scrollBorder]: type === 'create' ? true : !showDetails })}>
                <div id="containerDiv" className={clsx(classes.stickyContainer)}>
                    <CustomForm
                        ref={formRef}
                        showDetails={type === 'create' ? false : showDetails}
                        view={view}
                        stockId={stockId === undefined ? stockId : decryptedId}
                        type={type}
                        roleManagement={roleManagement}
                        loadTask={() => loadTask()}
                        classes={classes}
                        dispatch={dispatch}
                        clsx={clsx}
                        customerApi={(s = '', id = '') => customerApi(s, id)}
                        supplierApi={(s = '', id = '') => supplierApi(s, id)}
                        {...props}
                    />
                </div>
            </div>
        </Fragment>
    )
}

export default AdjustStockCreate